import React from "react";
import { Center, Heading, Text} from "@chakra-ui/react";
import { Helmet } from "react-helmet-async";

// The main content is not intended to be used. It will consist of routes to actual pages.
const Content = () => {

    const endpoint = (window.location.origin === "https://forms.maitland.nsw.gov.au" ? 
        process.env.REACT_APP_APIURL : process.env.REACT_APP_NONPRODAPIURL);

    return (
        <>
            <Helmet>
                <meta http-equiv="Content-Security-Policy" content={`default-src 'self'; style-src 'self' https://maitlandapi.wpengine.com/mccds/ 'unsafe-inline'; 
                    connect-src 'self' ${endpoint}`} />
            </Helmet>
            <br />
            <Center>
                <Heading className="title">Maitland City Council - Forms</Heading>
            </Center>
            <br />
            <Center><Text fontSize="3xl">Navigation</Text></Center>
            <br />
            <Center><Text fontSize="xl">Property Certificates: /propertyCertificates</Text></Center>
            <Center><Text fontSize="xl">Rates Payments: /rates</Text></Center>
            <Center><Text fontSize="xl">Debtors Payments: /debtors</Text></Center>
            <Center><Text fontSize="xl">Waste Services: /wasteServices</Text></Center>
            <Center><Text fontSize="xl">Bin Search: /bincollection</Text></Center>
            <Center><Text fontSize="xl">Maitland Pools: /maitland-pools</Text></Center>
            <Center><Text fontSize="xl">East Maitland Pool: /east-maitland-pool</Text></Center>
        </>
    );
}

export default Content;